/*
包含n个接口请求函数的模块
函数的返回值: promise对象
 */
import ajax from './ajax'
// const BASE_URL = '/api/api.php';

// 线上：
const BASE_URL = '/api.php';

// 1.获取logo
export const getLogo = ()=> ajax(`${BASE_URL}/cms/site/name/logo`);

// 2.获取产品子类
export const getProductNav = ()=> ajax(`${BASE_URL}/cms/nav/scode/5`);
export const getProductNavcn = ()=> ajax(`${BASE_URL}/cms/nav/scode/43`);

// 3.获取banner
export const getBanner = ()=> ajax(`${BASE_URL}/cms/slide/gid/1`);
export const getBannercn = ()=> ajax(`${BASE_URL}/cms/slide/gid/3`);

// 4.获取首页关于我们
export const getHomeAbout = ()=> ajax(`${BASE_URL}/content/36`);
export const getHomeAboutcn = ()=> ajax(`${BASE_URL}/content/237`);

// 5.获取自定义标签
export const getLable = ()=> ajax(`${BASE_URL}/cms/label`);

//6.获取首页推荐新闻
export const getHomeRecNews = ()=> ajax(`${BASE_URL}/list/2/num/1/order/isrecommend `);
export const getHomeRecNewscn = ()=> ajax(`${BASE_URL}/list/47/num/1/order/isrecommend `);

//7.获取首页top新闻
export const getHomeTopNews = ()=> ajax(`${BASE_URL}/list/2/num/3/order/istop `);
export const getHomeTopNewscn = ()=> ajax(`${BASE_URL}/list/47/num/3/order/istop `);


// 8、公司信息接口
export const getCompany =()=>ajax(`${BASE_URL}/cms/company`);

// 9.网站信息接口
export const getSite =()=>ajax(`${BASE_URL}/cms/site`);

// 10.底部信息
// 网站信息接口单个调用
export const getCopyright =()=>ajax(`${BASE_URL}/cms/site/name/copyright`);

// 11.获取关于我们栏目信息接口
export const getAboutInfo =()=>ajax(`${BASE_URL}/cms/sort/scode/1 `);

// #12.获取专题，传入序号：如：
// 获取企业文化id=207
export const getContent = (id)=> ajax(`${BASE_URL}/content/${id}`);

// #13.获取指定内容列表，传入栏目scode序号：如：
// 获取荣誉资质scode=17
export const getList = (scode)=> ajax(`${BASE_URL}/list/${scode}`);
export const getListPage = (scode,num,curpage)=> ajax(`${BASE_URL}/list/${scode}/num/${num}/page/${curpage}`);

// #14.指定分类信息接口
export const getSort =(scode)=>ajax(`${BASE_URL}/cms/sort/scode/${scode}`);

// #15.栏目列表树接口--获取指定分类的子类
export const getNav = (scode)=> ajax(`${BASE_URL}/cms/nav/scode/${scode}`);

// #16.搜索内容接口
export const getSearch = (key,data)=> ajax(`${BASE_URL}/cms/search/keyword/${key}/scode/5`,data,"POST");

// 17.获取网站地图
export const getSiteMap = ()=> ajax(`${BASE_URL}/cms/nav`);


// WEBPACK FOOTER //
// ./src/api/index.js